// project-imports
import {
  GET_DOMAIN_BEGIN,
  GET_DOMAIN_FAILURE,
  GET_DOMAIN_SUCCESS,
} from "../constants/actions";

// State variable initialization
export const initialState = {
  coursesDomain: "all",
  domainLoading: false,
  domainError: null,
};

const domainReducer = (state = initialState, action) => {

  if (action.type === GET_DOMAIN_BEGIN) {
    // Set loading state
    return {
      ...state,
      domainLoading: true,
      domainError: null,
    };
  }

  if (action.type === GET_DOMAIN_SUCCESS) {
    // Update state with domain name
    return {
      ...state,
      domainLoading: false,
      coursesDomain: action.payload.coursesDomain,
      domainError: null,
    };
  }

  if (action.type === GET_DOMAIN_FAILURE) {
    // Set error state
    return {
      ...state,
      domainLoading: false,
      domainError: action.payload,
    };
  }

  return state;
};

export default domainReducer;
